import { createStore, applyMiddleware, compose, Store } from 'redux';
import { rootReducer } from './reducers';
import thunk from 'redux-thunk';
import { IRootState } from 'commons/types';

const composeEnhancers =
  (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const store: Store<IRootState> & { dispatch: any } = createStore(
  rootReducer,
  composeEnhancers(applyMiddleware(thunk))
);

export default store;
